import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gdrive_active",
  "use": "gdrive_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"gdrive_active\"><path fill-rule=\"evenodd\" d=\"m5.604 2.725 3.217 5.856-6.167 8.843L0 13 5.604 2.725ZM6.342 2H13l5.455 10h-6.658L6.342 2ZM3.466 18l3.464-5H19l-3 5H3.466Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol